export default __webpack_public_path__ + "static/media/gmx-logo-final-white.f5dcc00a.png";